import { createFileRoute, redirect } from "@tanstack/react-router";

/** The homepage owns the overview; practical platform details now live in Pricing. */
export const Route = createFileRoute("/_home/platform")({
  ssr: true,
  beforeLoad: () => {
    throw redirect({ to: "/pricing", hash: "included", statusCode: 301 });
  },
});
